/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Money_Chart_HintInputs */

const vi_my_grower_report_money_chart_hint = /** @type {(inputs: My_Grower_Report_Money_Chart_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cột càng cao là nhận càng nhiều tiền. Vuốt ngang để xem kỳ cũ hơn.`)
};

/**

* @param {My_Grower_Report_Money_Chart_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_money_chart_hint = /** @type {((inputs?: My_Grower_Report_Money_Chart_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Money_Chart_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_money_chart_hint(inputs)
});